module.exports = "https://static.wmbcdn.com/uniweb/images/84f04e0695ec7d8b947329e7838dc574.svg";